/**
 * Object with all language data.
 *
 * When adding a language:
 *  - Add entry to this object
 *  - Add language code to webpack.config.prod.js to
 *    prevent unnecessary imported data according to momentCode
 *
 * Data explanation
 * @description : Name of the language in the respective language.
 *      Since we don't load all languages on load we want the description statically.
 * @fileCode : Name of the translation file {fileCode}.json
 * @i18nIsoCode : Code used by the i18next configuration. Available codes at
 *      https://github.com/michaelwittig/node-i18n-iso-countries/tree/master/langs
 * @momentCode : Used to import locales for moment. Available codes at
 *      https://github.com/moment/moment/tree/develop/locale
 * @electronSpellCheck : Spell check when writing text. Check the available languages
 *      by logging this in an electron environment
 *      const possibleLanguages = mainWindow.webContents.session.availableSpellCheckerLanguages.
 * @supportLink : Link to support page in general settings.
 *      Null will default to https://support.telavox.com/.
 */

export const LocalesData = Object.freeze({
    sv: {
        description: 'Svenska',
        fileCode: 'sv',
        i18nIsoCode: 'sv',
        momentCode: 'sv',
        electronSpellCheck: 'sv',
        supportLink: 'https://support.telavox.com/sv_SE',
        direction: 'ltr',
    },

    da: {
        description: 'Dansk',
        fileCode: 'da',
        i18nIsoCode: 'da',
        momentCode: 'da',
        electronSpellCheck: 'da',
        supportLink: null,
        direction: 'ltr',
    },
    nb: {
        description: 'Norsk',
        fileCode: 'nb',
        i18nIsoCode: 'nb',
        momentCode: 'nb',
        electronSpellCheck: 'nb',
        supportLink: null,
        direction: 'ltr',
    },
    fi: {
        description: 'Suomi',
        fileCode: 'fi',
        i18nIsoCode: 'fi',
        momentCode: 'fi',
        electronSpellCheck: null,
        supportLink: null,
        direction: 'ltr',
    },
    fo: {
        description: 'Føroyar',
        fileCode: 'fo',
        i18nIsoCode: null,
        momentCode: 'fo',
        electronSpellCheck: 'fo',
        supportLink: null,
        direction: 'ltr',
    },
    is: {
        description: 'Íslenska',
        fileCode: 'is',
        i18nIsoCode: 'is',
        momentCode: 'is',
        electronSpellCheck: 'is',
        supportLink: null,
        direction: 'ltr',
    },
    ca: {
        description: 'Català',
        fileCode: 'ca',
        i18nIsoCode: 'ca',
        momentCode: 'ca',
        electronSpellCheck: 'ca',
        supportLink: null,
        direction: 'ltr',
    },
    'fr-FR': {
        description: 'Français',
        fileCode: 'fr',
        i18nIsoCode: 'fr',
        momentCode: 'fr',
        electronSpellCheck: 'fr-FR',
        supportLink: null,
        direction: 'ltr',
    },
    'es-419': {
        description: 'Español (LA)',
        fileCode: 'es',
        i18nIsoCode: 'es',
        momentCode: 'es',
        electronSpellCheck: 'es-419',
        supportLink: null,
        direction: 'ltr',
    },
    'es-ES': {
        description: 'Español',
        fileCode: 'es-ES',
        i18nIsoCode: 'es',
        momentCode: 'es',
        electronSpellCheck: 'es-ES',
        supportLink: null,
        direction: 'ltr',
    },
    'nl-BE': {
        description: 'Nederlands (België)',
        fileCode: 'nl-BE',
        i18nIsoCode: 'nl',
        momentCode: 'nl-be',
        electronSpellCheck: 'nl',
        supportLink: null,
        direction: 'ltr',
    },
    'nl-NL': {
        description: 'Nederlands',
        fileCode: 'nl-NL',
        i18nIsoCode: 'nl',
        momentCode: 'nl',
        electronSpellCheck: 'nl',
        supportLink: null,
        direction: 'ltr',
    },
    'pt-PT': {
        description: 'Português',
        fileCode: 'pt-PT',
        i18nIsoCode: 'pt',
        momentCode: 'pt',
        electronSpellCheck: 'pt-PT',
        supportLink: null,
        direction: 'ltr',
    },
    'it-IT': {
        description: 'Italiano',
        fileCode: 'it',
        i18nIsoCode: 'it',
        momentCode: 'it',
        electronSpellCheck: 'it-IT',
        supportLink: null,
        direction: 'ltr',
    },
    'de-DE': {
        description: 'Deutsch',
        fileCode: 'de',
        i18nIsoCode: 'de',
        momentCode: 'de',
        electronSpellCheck: 'de-DE',
        supportLink: null,
        direction: 'ltr',
    },
    ar: {
        description: 'عربي',
        fileCode: 'ar',
        i18nIsoCode: 'ar',
        momentCode: 'ar',
        electronSpellCheck: 'ar',
        supportLink: null,
        direction: 'rtl',
    },
    en: {
        description: 'English',
        fileCode: 'en',
        i18nIsoCode: 'en',
        momentCode: 'en-gb',
        electronSpellCheck: 'en-GB',
        supportLink: 'https://support.telavox.com/en_US',
        direction: 'ltr',
    },
});
